// RTI Officer entity interface
export interface RTIOfficer {
  id: number;
  section_number: number;
  serial_number: number;
  name: string;
  designation: string;
  post: string;
  subjects_allotted: string;
  address: string;
  mobile_number: string;
  email?: string;
  is_active: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
}

// Form data interface
export interface RTIOfficerFormData {
  section_number: number;
  serial_number: number;
  name: string;
  designation: string;
  post: string;
  subjects_allotted: string;
  address: string;
  mobile_number: string;
  email?: string;
  is_active: boolean;
  display_order: number;
}

// API Response interface
export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
  error?: string;
}

// Post types
export const POST_TYPES = [
  'Appellate Authority',
  'PIO',
  'PIO-I',
  'PIO-II',
  'APIO',
  'APIO-I',
  'APIO-II',
  'APIO-III',
] as const;

// Section names
export const SECTION_NAMES: { [key: number]: string } = {
  1: 'Administration, Budget, Accounts and loans',
  2: 'CSS and State Projects, PMGSY & Buildings',
  3: 'MRR',
  4: 'Vig & Quality Control',
  5: 'Designs, MIS & Planning and MGNREGS',
  6: 'SQC',
};

// Roman numerals for sections
export const ROMAN_NUMERALS = ['I', 'II', 'III', 'IV', 'V', 'VI'];
